<script setup lang="ts">
import type { UspListData } from '~/utils/crystallize/pieces'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'

defineProps<{
  title: UspListData['title']
  usps: UspListData['usp']
}>()
</script>

<template>
  <section v-if="usps?.length" class="w-full py-xl">
    <ContentGrid class="gap-y-l sm:gap-y-2xl">
      <h2 class="title-l full-width-content text-center" v-text="title" />

      <ul class="full-width-content grid grid-cols-subgrid gap-y-4 sm:gap-y-8">
        <li v-for="(usp, i) in usps" :key="usp.title || i" class="col-span-4 2xl:col-span-5 flex items-center gap-m md:gap-l">
          <Shape variant="star" class="hidden xs:block fill-blurple-100 size-15 min-w-15 text-primary" :icon="faCheck" />

          <div class="flex flex-col gap-2xs">
            <strong class="title-s" v-text="usp.title" />
            <CrystallizeRichText v-for="(block, j) in usp.text" :key="j" :block="block" />
          </div>
        </li>
      </ul>
    </ContentGrid>
  </section>
</template>
